import type { AnimationEventHandler, FC, PropsWithChildren } from 'react';
import React from 'react';

import { cnTextinput } from '../Textinput.cn';

import './Textinput-Hint.css';

export type TextinputHintProps = PropsWithChildren<{
    leave: boolean;
    onAnimationEnd: AnimationEventHandler<HTMLSpanElement>;
    id?: string;
}>;

export const TextinputHint: FC<TextinputHintProps> = ({ leave, onAnimationEnd, children, id }) => (
    <span className={cnTextinput('Hint', { leave })} onAnimationEnd={onAnimationEnd} id={id}>
        {children}
    </span>
);
